import axios from 'axios';

const API_URL = process.env.VUE_APP_API_URL + 'v1/drivers';

class driversService {
    /**
     * Tworzy nowego kierowcę, wysyłając dane kierowcy do endpointu.
     * 
     * @param {Object} driver - Obiekt zawierający dane nowego kierowcy.
     * @returns {Promise<Object>} Zwraca odpowiedź z serwera po pomyślnym utworzeniu kierowcy.
     */
    createDriver(driver) {
        return axios.post(API_URL, driver);
    }

    /**
     * Pobiera listę wszystkich kierowców.
     * 
     * @returns {Promise<Object>} Zwraca odpowiedź z serwera zawierającą listę wszystkich kierowców.
     */
    getAllDrivers() {
        return axios.get(API_URL);
    }

    getAllDriversArchive() {
        return axios.get(API_URL + '/archive');
    }

    /**
     * Pobiera dane kierowcy na podstawie jego identyfikatora (ID).
     * 
     * @param {number|string} id - ID kierowcy, którego chcemy pobrać.
     * @returns {Promise<Object>} Zwraca dane kierowcy o podanym ID.
     */
    getDriverById(id) {
        return axios.get(`${API_URL}/${id}`);
    }

    /**
     * Aktualizuje dane kierowcy na podstawie jego identyfikatora (ID).
     * 
     * @param {number|string} id - ID kierowcy, którego chcemy zaktualizować.
     * @param {Object} updatedDriver - Obiekt zawierający zaktualizowane dane kierowcy.
     * @returns {Promise<Object>} Zwraca odpowiedź z serwera po pomyślnej aktualizacji danych kierowcy.
     */
    updateDriver(id, updatedDriver) {
        return axios.put(`${API_URL}/${id}`, updatedDriver);
    }

    /**
     * Usuwa kierowcę na podstawie jego identyfikatora (ID).
     * 
     * @param {number|string} id - ID kierowcy, którego chcemy usunąć.
     * @returns {Promise<void>} Zwraca odpowiedź z serwera po pomyślnym usunięciu kierowcy.
     */
    deleteDriver(id) {
        return axios.delete(`${API_URL}/${id}`);
    }

    updateDriverStatus(driverId) {
        return axios.put(`${API_URL}/${driverId}/toggle-status`);
    }

    heartBeat(driverId) {
        return axios.put(`${API_URL}/${driverId}/heartbeat`);
    }

    restoreDriver(id) {
        return axios.put(`${API_URL}/${id}/restore`);
    }
}

export default new driversService();
